import joi from 'joi';

import {
  type AttributeFilters,
  attributeFiltersSchema,
} from '../attributeFilters';
import type {
  GraphIntentSummary,
  GraphIntentVerificationBadge,
  IntentRuleId,
} from '../graphOverlay/graphIntent';
import type { WithSnapshot } from '../snapshot';
import {
  type GraphPathLookupParameters,
  graphPathLookupParametersSchema,
} from './GraphPathLookupParameters';
import {
  type GraphRequestSettings,
  graphRequestSettingsSchema,
} from './GraphRequest';
import {
  type GraphTopologyParameters,
  graphTopologyParametersSchema,
} from './GraphTopologyParameters';

export interface IntentRule {
  id: IntentRuleId;
  column?: string;
  name: string;
  webEndpoint?: string;
}

export interface IntentSummaryRequestBody extends WithSnapshot {
  attributeFilters?: AttributeFilters;
  settings?: GraphRequestSettings;
  parameters: GraphTopologyParameters | GraphPathLookupParameters;
}

export const intentSummaryRequestBodySchema = joi.object().keys({
  attributeFilters: attributeFiltersSchema,
  snapshot: joi.string().required(),
  settings: graphRequestSettingsSchema,
  parameters: joi
    .alternatives([
      graphTopologyParametersSchema,
      graphPathLookupParametersSchema,
    ])
    .required(),
});

export type IntentSummaryResponseBody = GraphIntentSummary;

export interface PathChecksBadgeRequestBody extends WithSnapshot {}

export const pathChecksBadgeRequestBodySchema = joi.object().keys({
  snapshot: joi.string().required(),
});

export type PathChecksBadgeResponseBody = GraphIntentVerificationBadge;
